/* eslint-disable camelcase */
import request from '@/utils/request'

export function authForm (p_query) {
  return request({
    url: '/form/auth/' + p_query.form_id,
    method: 'get',
    params: p_query
  })
}

export function detailForm (p_query, p_headers) {
  return request({
    headers: p_headers,
    url: '/form/detail/' + p_query.form_id,
    method: 'get',
    params: p_query
  })
}

export function updateForm (p_data, p_headers) {
  return request({
    headers: p_headers,
    url: '/form/' + p_data.form_id,
    method: 'put',
    data: p_data
  })
}

export function deleteFormFile (p_data, p_headers) {
  return request({
    headers: p_headers,
    url: '/form/' + p_data.form_id + '/file',
    method: 'delete',
    data: p_data
  })
}



// WEBPACK FOOTER //
// ./src/api/form.js